import React, { useState } from "react";
import { useLanguage } from "../tools/LanguageContext";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

function Profile() {
  const { translations } = useLanguage();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("changePassword");

  const token = localStorage.getItem("token");
  const [passwordFormData, setPasswordFormData] = useState({ oldPassword: "", newPassword: "", repeatNewPassword: "" });
  const [emailFormData, setEmailFormData] = useState({ newEmail: "", password: "" });

  const handleChangePassword = (e) => {
    setPasswordFormData({ ...passwordFormData, [e.target.name]: e.target.value });
  };

  const handleChangeEmail = (e) => {
    setEmailFormData({ ...emailFormData, [e.target.name]: e.target.value });
  };

  const handleSubmitPassword = async (e) => {
    e.preventDefault();

    if (passwordFormData.newPassword !== passwordFormData.repeatNewPassword) {
      alert(translations.alertRepeatPasswordWrong);
    }
    else {
      try {
        const response = await axios.post("https://artofbetting.gr/api/change_password", passwordFormData, {
          headers: {
            "Authorization": token,
          }
        });

        if (response.status === 200) {
          // Alert για επιτυχία
          alert(translations.alertSuccessPasswordChange);

          // Redirect στο home
          localStorage.removeItem("token");
          navigate("/");
        }
      } catch (error) {
        // Έλεγχος του status code για να εμφανιστεί το κατάλληλο μήνυμα
        if (error.response?.status === 403) {
          alert(translations.alertInvalidPassword);
        } else if (error.response?.status === 401) {
          alert(translations.alertTokenExpired);
          // Redirect στο home
          localStorage.removeItem("token");
          navigate("/");
        }
        else {
          alert(translations.alertServerError);
        }
      }
    }
  };

  const handleSubmitEmail = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post("https://artofbetting.gr/api/change_email", emailFormData , {
        headers: {
          "Authorization": token,
        }
      });

      if (response.status === 200) {
        // Alert για επιτυχή σύνδεση
        alert(translations.alertSuccessEmailChange);

        // Redirect στο home
        localStorage.removeItem("token");
        navigate("/");
      }
    } catch (error) {
      // Έλεγχος του status code για να εμφανιστεί το κατάλληλο μήνυμα
      if (error.response?.status === 403) {
        alert(translations.alertInvalidPassword);
      } else if (error.response?.status === 409) {
        alert(translations.alertEmailExists);
      } else if (error.response?.status === 401) {
        alert(translations.alertTokenExpired);
        // Redirect στο home
        localStorage.removeItem("token");
        navigate("/");
      }
      else {
        alert(translations.alertServerError);
      }
    }
  };

  const renderContent = () => {
    switch (activeTab) {
      case "changePassword":
        return (
          <form className="bg-gray-800 p-6 rounded shadow-lg" onSubmit={handleSubmitPassword}>
            <h2 className="text-xl font-bold mb-4 text-white">{translations.changePassword}</h2>
            <div className="mb-4">
              <label className="block text-gray-400 mb-2">{translations.oldPassword}</label>
              <input
                type="password"
                className="w-full px-4 py-2 rounded bg-gray-700 text-white"
                name="oldPassword"
                value={passwordFormData.oldPassword}
                onChange={handleChangePassword}
                required
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-400 mb-2">{translations.newPassword}</label>
              <input
                type="password"
                className="w-full px-4 py-2 rounded bg-gray-700 text-white"
                name="newPassword"
                value={passwordFormData.newPassword}
                onChange={handleChangePassword}
                required
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-400 mb-2">{translations.repeatNewPassword}</label>
              <input
                type="password"
                className="w-full px-4 py-2 rounded bg-gray-700 text-white"
                name="repeatNewPassword"
                value={passwordFormData.repeatNewPassword}
                onChange={handleChangePassword}
                required
              />
            </div>
            <button className="bg-green-800 px-4 py-2 rounded text-white hover:bg-green-900">
              {translations.saveChanges}
            </button>
          </form>
        );
      case "changeEmail":
        return (
          <form className="bg-gray-800 p-6 rounded shadow-lg" onSubmit={handleSubmitEmail}>
            <h2 className="text-xl font-bold mb-4 text-white">{translations.changeEmail}</h2>
            <div className="mb-4">
              <label className="block text-gray-400 mb-2">{translations.newEmail}</label>
              <input
                type="email"
                className="w-full px-4 py-2 rounded bg-gray-700 text-white"
                name="newEmail"
                value={emailFormData.newEmail}
                onChange={handleChangeEmail}
                required
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-400 mb-2">{translations.password}</label>
              <input
                type="password"
                className="w-full px-4 py-2 rounded bg-gray-700 text-white"
                name="password"
                value={emailFormData.password}
                onChange={handleChangeEmail}
                required
              />
            </div>
            <button className="bg-green-800 px-4 py-2 rounded text-white hover:bg-green-900">
              {translations.saveChanges}
            </button>
          </form>
        );
      default:
        return null;
    }
  };

  return (
    <div className="bg-gray-900 text-white min-h-screen p-4">
      {/* Header */}
      <header className="flex justify-between items-center p-4 bg-gray-800 mb-6 rounded-lg">
        <h1 className="text-3xl font-bold">ART OF BETTING</h1>
        <nav className="flex space-x-4">
          <Link to="/">
          <button className="bg-green-800 px-4 py-2 rounded hover:bg-green-900">
            {translations.home}
          </button>
          </Link>
        </nav>
      </header>

      {/* Title */}
      <h2 className="text-3xl font-bold mb-4">{translations.profile}</h2>

      {/* Navigation Tabs */}
      <div className="flex space-x-4 mb-6">
        <button
          className={`px-4 py-2 rounded ${
            activeTab === "changePassword"
              ? "bg-green-800 text-white"
              : "bg-gray-700 text-gray-400 hover:bg-gray-600"
          }`}
          onClick={() => setActiveTab("changePassword")}
        >
          {translations.changePassword}
        </button>
        <button
          className={`px-4 py-2 rounded ${
            activeTab === "changeEmail"
              ? "bg-green-800 text-white"
              : "bg-gray-700 text-gray-400 hover:bg-gray-600"
          }`}
          onClick={() => setActiveTab("changeEmail")}
        >
          {translations.changeEmail}
        </button>
      </div>

      {/* Content */}
      <div>{renderContent()}</div>

      <footer className="relative w-full bg-gray-900 py-8">
        <div className="flex flex-col items-center justify-between w-full">
          <p className="text-xl font-bold border-b border-t p-4 mb-8">© Copyright 2025 Art Of Betting</p>
          <p className="text-lg font-bold border-b border-t p-2 mb-8 text-center">
            <span className="font-semibold">Διαφημιστειτε εδώ:</span>{' '}
            <a href="mailto:artofbetting2025@gmail.com" className="hover:underline">
              artofbetting2025@gmail.com
            </a>
          </p>

          <div className="flex items-center justify-between w-2/5 mb-8">
            <a href="https://www.kethea.gr/" target="_blank" rel="noopener noreferrer" className="w-1/5 mr-8">
              <img
                src="images/21.svg"
                alt="21+"
                className="w-full h-auto"
              />
            </a>

            <a href="https://www.kethea.gr/" target="_blank" rel="noopener noreferrer" className="w-4/5">
              <img
                src="images/kethea.svg"
                alt="kethea"
                className="w-full h-auto"
              />
            </a>
          </div>

          <a href="https://certifications.gamingcommission.gov.gr/publicRecordsOnline/SitePages/AffiliatesOnline.aspx" target="_blank" rel="noopener noreferrer">
            <img
              src="images/eeep.png"
              alt="eeep"
              className="w-full h-auto border-b border-t p-4"
            />
          </a>
        </div>
      </footer>
    </div>
  );
}

export default Profile;
